// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
export const apiEndpoint = `https://${process.env.GATSBY_PRISMIC_API_ENDPOINT}.cdn.prismic.io/api/v2`;
export const resourceCenterUrl = `https://www.tripmastersoftware.com/resources`;
export const tagsEndpoint = `https://${process.env.GATSBY_PRISMIC_REPO_NAME}.cdn.prismic.io/api/tags`; // eslint-disable-line
